import React, { Component } from "react";
import PropTypes from "prop-types";
import { YearPicker, MonthPicker, DayPicker } from "react-dropdown-date";
import moment from "moment";
import InvalidFeedback from "../../../common/invalid_feedback";

class EndDateDropdown extends Component {
  constructor(props) {
    super(props);

    const endDate = props.initialEndDate && new Date(props.initialEndDate);

    // Copying props to state Anti-pattern solution
    // https://reactjs.org/blog/2018/06/07/you-probably-dont-need-derived-state.html#recommendation-fully-uncontrolled-component-with-a-key
    this.state = {
      year: endDate && endDate.getFullYear().toString(),
      month: endDate && endDate.getMonth().toString(),
      day: endDate && endDate.getDate().toString()
    };
  }

  onEndDateChange = () => {
    const { year, month, day } = this.state;
    const { experience, onExperienceChange } = this.props;

    if (year && month && day) {
      onExperienceChange(
        event,
        experience,
        moment().year(year).month(month).date(day).format("YYYY-MM-DD")
      );
    } else if (year == "" && month == "" && day == "") {
      onExperienceChange(event, experience);
    }
  }

  setFormControlClassName = () => {
    const { experience } = this.props;
    var className = "form-control";

    if (experience.errors.end_date) {
      className += " is-invalid";
    }

    return className;
  }

  render () {
    const { year, month, day } = this.state;
    const { index, experience } = this.props;

    return (
      <div className='col-12 col-md-6 mb-2 row no-gutters'>
        <div className='col-3 mr-2 mr-md-1 mr-lg-2'>
          <YearPicker
            defaultValue="年"
            start={1950}
            reverse
            required
            value={year}
            onChange={(year) => {
              this.setState({ year }, () => this.onEndDateChange());
            }}
            id={`career-experiences-attributes-${index}-end-year`}
            name="end_date"
            classes={this.setFormControlClassName()}
          />
          <InvalidFeedback errors={experience.errors.end_date} label='終了期間' />
        </div>
        <div className='col-3 mr-2 mr-md-1 mr-lg-2'>
          <MonthPicker
            defaultValue="月"
            numeric
            endYearGiven
            year={year}
            required
            value={month}
            onChange={(month) => {
              this.setState({ month }, () => this.onEndDateChange());
            }}
            id={`career-experiences-attributes-${index}-end-month`}
            name="end_date"
            classes={this.setFormControlClassName()}
          />
        </div>
        <div className='col-3'>
          <DayPicker
            defaultValue="日"
            year={year}
            month={month}
            endYearGiven
            required
            value={day}
            onChange={(day) => {
              this.setState({ day }, () => this.onEndDateChange());
            }}
            id={`career-experiences-attributes-${index}-end-day`}
            name="end_date"
            classes={this.setFormControlClassName()}
          />
        </div>
      </div>
    );
  }
}

EndDateDropdown.propTypes = {
  initialEndDate: PropTypes.string.isRequired,
  experience: PropTypes.shape({
    errors: PropTypes.object.isRequired
  }).isRequired,
  index: PropTypes.number.isRequired,
  onExperienceChange: PropTypes.func.isRequired
};

export default EndDateDropdown;
